import { $qs, $qsa } from '../../../src/js/utils/QuerySelector';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function apply() {
    
    var steps = $qsa('[data-step]');
    
    [...steps].forEach(step => { 
        var stepNumber = $qs('[data-step-number="'+step.dataset.step+'"]');  
        var bigStepNumber = $qs('[data-big-step-number="'+step.dataset.step+'"]');     
        //console.log(stepNumber);
        ScrollTrigger.create({
            trigger: step,
            start: 'top top+=300',
            end: 'bottom top+=300',    
            onEnter: () => {
                gsap.to(stepNumber, {color: '#FFFFFF', duration: 0.15, backgroundColor: '#633A9C' })
                gsap.to(bigStepNumber, {opacity: 1, duration: 0.2})
            },
            onLeave: () => {
                gsap.to(stepNumber, {color: '#311952', duration: 0.15, backgroundColor: '#FFFFFF' })
                gsap.to(bigStepNumber, {opacity: 0, duration: 0.2})
            },
            onEnterBack: () => {
                gsap.to(stepNumber, {color: '#FFFFFF', duration: 0.15, backgroundColor: '#633A9C' })
                gsap.to(bigStepNumber, {opacity: 1, duration: 0.2})
            },
            onLeaveBack: () => {
                gsap.to(stepNumber, {color: '#311952', duration: 0.15, backgroundColor: '#FFFFFF'})
                gsap.to(bigStepNumber, {opacity: 0, duration: 0.2})
            }
        }); 
        
    })
}

function applicationSteps() {
    if($qs('.block--application-steps')) {
        apply();
    }
}


export default applicationSteps;